"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const u=(r="",e)=>r.trim().split(/\s+/).reduce((t,o,s)=>((!e||s<e)&&t.push(o.charAt(0).toUpperCase()),t),[]).join("");exports.getNameInitials=u;
